<template>
    <div id="TaskGroup">

        <!-- Leave Task -->
        <div v-if="leaveTask.length > 0" class="tg-section">
            <div class="tg-header" @click="leaveOpen = !leaveOpen">
                <div class="tg-header-left">
                    <span class="tg-title">{{$t('selfservicemytask.leaveapplication')}}</span>
                    <span class="tg-count">{{ leaveTask.length }}</span>
                </div>
                <div class="tg-header-right" @click.stop>
                    <span class="tg-select-all" @click.stop="toggleSelectAll">
                        <v-icon size="18" class="tg-sel-icon" :color="selectAllLeaveLocal ? 'white' : 'rgba(255,255,255,0.6)'">
                            {{ selectAllLeaveLocal ? 'mdi-checkbox-marked' : 'mdi-checkbox-blank-outline' }}
                        </v-icon>
                        <span class="tg-select-label">{{$t('claimbalancemobile.selectall')}}</span>
                    </span>
                    <v-select
                        :items="actionButton"
                        :label="actionButtonLabel"
                        @input="$emit('leave-action', $event, leaveTask)"
                        dense outlined clearable hide-details
                        class="tg-action-select"
                        @click.stop
                    ></v-select>
                    <v-btn icon small class="tg-toggle-btn" @click="leaveOpen = !leaveOpen">
                        <v-icon color="white" size="20">{{ leaveOpen ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                    </v-btn>
                </div>
            </div>
            <div v-show="leaveOpen" class="tg-body">
                <div v-for="(item, index) in leaveTask" :key="index"
                    class="tg-row" :class="{ 'tg-row-alt': index % 2 !== 0 }"
                    @click="$emit('leave-route-details', item)">
                    <div class="tg-row-text">
                        <span class="task-name">{{item.psnname}}</span>
                        <span class="task-connector"> {{$t('homemobile.submitted')}} </span>
                        <span class="task-type">{{item.leavedesc}}</span>
                        <span class="task-connector"> {{$t('homemobile.timerelatedon')}} </span>
                        <span class="task-date">{{item.entrytime}}</span>
                    </div>
                    <v-checkbox v-model="item.active" dense hide-details class="tg-row-check" @click.stop></v-checkbox>
                </div>
            </div>
        </div>

        <!-- Claim Task -->
        <div v-if="claimTask.length > 0" class="tg-section">
            <div class="tg-header" @click="claimOpen = !claimOpen">
                <div class="tg-header-left">
                    <span class="tg-title">{{$t('selfservicemytask.claimapplication')}}</span>
                    <span class="tg-count">{{ claimTask.length }}</span>
                </div>
                <div class="tg-header-right">
                    <v-btn icon small class="tg-toggle-btn" @click.stop="claimOpen = !claimOpen">
                        <v-icon color="white" size="20">{{ claimOpen ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                    </v-btn>
                </div>
            </div>
            <div v-show="claimOpen" class="tg-body">
                <div v-for="(item, index) in claimTask" :key="index"
                    class="tg-row" :class="{ 'tg-row-alt': index % 2 !== 0 }"
                    @click="$emit('claim-route', item)">
                    <span class="task-name">{{item.claimdetails[0].staffname}}</span>
                    <span class="task-connector"> {{$t('homemobile.submitted')}} </span>
                    <span class="task-type">{{item.clmtypdesc}}</span>
                    <span class="task-connector"> {{$t('homemobile.timerelatedon')}} </span>
                    <span class="task-date">{{item.claimdetails[0].entrytime}}</span>
                </div>
            </div>
        </div>

        <!-- KPI Task -->
        <div v-if="KPITask.length > 0" class="tg-section">
            <div class="tg-header" @click="kpiOpen = !kpiOpen">
                <div class="tg-header-left">
                    <span class="tg-title">{{$t('performancemanagement.kpisetting')}}</span>
                    <span class="tg-count">{{ KPITask.length }}</span>
                </div>
                <div class="tg-header-right">
                    <v-btn icon small class="tg-toggle-btn" @click.stop="kpiOpen = !kpiOpen">
                        <v-icon color="white" size="20">{{ kpiOpen ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                    </v-btn>
                </div>
            </div>
            <div v-show="kpiOpen" class="tg-body">
                <div v-for="(item, index) in KPITask" :key="index"
                    class="tg-row" :class="{ 'tg-row-alt': index % 2 !== 0 }"
                    @click="goToKPI(item)">
                    <span class="task-name">{{ item.staffname }} ({{ item.staffcode }})</span>
                    <span class="task-connector"> {{$t('homemobile.submitted')}} </span>
                    <span class="task-type">{{ item.title }}</span>
                    <span class="task-connector"> {{$t('payrollpivotreport.from')}} </span>
                    <span class="task-date">{{ item.startdate }} — {{ item.enddate }}</span>
                </div>
            </div>
        </div>

        <!-- Review Exercise Task -->
        <div v-if="reviewExerciseTask.length > 0" class="tg-section">
            <div class="tg-header" @click="reviewOpen = !reviewOpen">
                <div class="tg-header-left">
                    <span class="tg-title">{{$t('pmselfservice.reviewexercise')}}</span>
                    <span class="tg-count">{{ reviewExerciseTask.length }}</span>
                </div>
                <div class="tg-header-right">
                    <v-btn icon small class="tg-toggle-btn" @click.stop="reviewOpen = !reviewOpen">
                        <v-icon color="white" size="20">{{ reviewOpen ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                    </v-btn>
                </div>
            </div>
            <div v-show="reviewOpen" class="tg-body">
                <div v-for="(item, index) in reviewExerciseTask" :key="index"
                    class="tg-row" :class="{ 'tg-row-alt': index % 2 !== 0 }"
                    @click="goToReviewExercise(item)">
                    <span class="task-name">{{ item.staffname }} ({{ item.staffcode }})</span>
                    <span class="task-connector"> {{$t('homemobile.submitted')}} </span>
                    <span class="task-type">{{ item.reviewname }}</span>
                    <span class="task-connector"> {{$t('payrollpivotreport.from')}} </span>
                    <span class="task-date">{{ item.reviewfromdate }} — {{ item.reviewuntildate }}</span>
                </div>
            </div>
        </div>

        <div v-if="KPITask.length < 1 && leaveTask.length < 1 && claimTask.length < 1 && reviewExerciseTask.length < 1"
            class="tg-empty">{{$t('homemobile.notask')}}</div>

    </div>
</template>

<script>

export default {
    
    props: {
        leaveTask: Array,
        claimTask: Array,
        KPITask: Array,
        reviewExerciseTask: Array,
        actionButton: Array,
        actionButtonLabel: String
    },
    data() {
        return {
            selectAllLeaveLocal: false,
            kpiOpen: true,
            reviewOpen: true,
            leaveOpen: true,
            claimOpen: true,
        }
    },

    methods: {
        toggleSelectAll() {
            this.selectAllLeaveLocal = !this.selectAllLeaveLocal;
            this.$emit('select-all-leave', this.selectAllLeaveLocal);
        },

        goToKPI(kpi) {
            console.log("KPI: ", kpi);
            this.$router.push({ name: "selfservicekpidetails", params: { kpi : kpi} });
        },

        goToReviewExercise(review) {
            console.log("RV: ", review);
            this.$router.push({ name: "selfservicereviewdetails", params: { review : review } });
        },
    }

}
</script>

<style>
.tg-section {
    margin-bottom: 10px;
    border-radius: 10px;
    overflow: hidden;
    border: 1px solid #E8EDF5;
    box-shadow: 0 1px 4px rgba(0,0,0,0.04);
}
.tg-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: linear-gradient(135deg, #1a3a5c 0%, #2d5a8e 100%);
    padding: 10px 14px;
    min-height: 48px;
    gap: 12px;
    cursor: pointer;
}
.tg-header-left {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
}
.tg-title {
    font-size: 0.85rem;
    font-weight: 700;
    color: #ffffff;
    letter-spacing: 0.01em;
}
.tg-count {
    background: rgba(255,255,255,0.25);
    color: #ffffff;
    font-size: 0.72rem;
    font-weight: 700;
    border-radius: 20px;
    padding: 2px 8px;
    min-width: 24px;
    text-align: center;
}
.tg-header-right {
    display: flex;
    align-items: center;
    gap: 10px;
    justify-content: flex-end;
}
.tg-select-all {
    display: flex;
    align-items: center;
    gap: 5px;
    cursor: pointer;
    user-select: none;
    flex-shrink: 0;
}
.tg-sel-icon { flex-shrink: 0; }
.tg-select-label {
    font-size: 0.78rem;
    color: rgba(255,255,255,0.9);
    white-space: nowrap;
}
.tg-toggle-btn { flex-shrink: 0; }
.tg-action-select {
    max-width: 150px !important;
    flex-shrink: 0;
}
/* White background, dark text, consistent border radius */
.tg-action-select .v-input__slot {
    background: #ffffff !important;
    border-radius: 8px !important;
    min-height: 32px !important;
    box-shadow: none !important;
}
/* Normal border */
.tg-action-select .v-input__slot fieldset {
    border: 1.5px solid rgba(255,255,255,0.5) !important;
    border-radius: 8px !important;
}
/* Focused border — match the slot shape exactly */
.tg-action-select.v-input--is-focused .v-input__slot fieldset,
.tg-action-select .v-input__slot:focus-within fieldset {
    border: 1.5px solid #4F6BFF !important;
    border-radius: 8px !important;
}
.tg-action-select .v-label { color: #1a3a5c !important; font-size: 0.78rem !important; }
.tg-action-select .v-select__selection { color: #1a3a5c !important; font-size: 0.78rem !important; }
.tg-action-select .v-icon { color: #1a3a5c !important; }
/* Remove default Vuetify blue outline that mismatches */
.tg-action-select .v-input__slot::before,
.tg-action-select .v-input__slot::after { display: none !important; }

/* Body rows */
.tg-body { background: #ffffff; }
.tg-row {
    display: flex;
    align-items: center;
    padding: 7px 14px;
    cursor: pointer;
    font-size: 0.82rem;
    border-bottom: 1px solid #F1F5F9;
    transition: background 0.12s;
    flex-wrap: wrap;
    gap: 0;
}
.tg-row:hover { background: #F5F7FF !important; }
.tg-row:last-child { border-bottom: none; }
.tg-row-alt { background: #FAFBFF; }
.tg-row-text { flex: 1; display: flex; align-items: center; flex-wrap: wrap; }
.tg-row-check { margin: 0 !important; padding: 0 !important; margin-left: auto !important; flex-shrink: 0; }

/* Task row spans */
.task-name      { font-weight: 600; color: #1a3a5c; letter-spacing: normal; }
.task-type      { font-weight: 600; color: #4F6BFF; letter-spacing: normal; }
.task-date      { color: #64748B; letter-spacing: normal; }
.task-connector { color: #94a3b8; font-size: 0.78rem; margin: 0 2px; }

.tg-empty {
    padding: 24px 16px;
    font-size: 0.85rem;
    color: #64748B;
    text-align: center;
}
</style>